import type { GuideFiles } from "./loader";

export type GuideHotModule = string | { default: unknown };

export function readGuideHotModuleText(module: GuideHotModule, path: string): string {
  if (typeof module === "string") {
    return module;
  }

  if (typeof module.default === "string") {
    return module.default;
  }

  throw new Error(`Invalid HMR guide module for ${path}: expected text import module`);
}

export function createGuideFilesFromHotModules(
  guidePaths: readonly string[],
  modules: readonly GuideHotModule[]
): GuideFiles {
  if (modules.length !== guidePaths.length) {
    throw new Error(
      `Invalid guide module registry: expected ${guidePaths.length} modules, received ${modules.length}`
    );
  }

  const guideFiles: GuideFiles = {};

  for (const [index, module] of modules.entries()) {
    const path = guidePaths[index];
    guideFiles[path] = readGuideHotModuleText(module, path);
  }

  return guideFiles;
}

export function applyGuideHotUpdates(
  currentGuideFiles: GuideFiles,
  guidePaths: readonly string[],
  updatedModules: readonly (GuideHotModule | undefined)[]
): GuideFiles {
  if (updatedModules.length !== guidePaths.length) {
    throw new Error(
      `Invalid HMR guide update: expected ${guidePaths.length} modules, received ${updatedModules.length}`
    );
  }

  let hasUpdates = false;
  const nextGuideFiles: GuideFiles = { ...currentGuideFiles };

  for (const [index, module] of updatedModules.entries()) {
    if (module === undefined) {
      continue;
    }

    const path = guidePaths[index];
    nextGuideFiles[path] = readGuideHotModuleText(module, path);
    hasUpdates = true;
  }

  return hasUpdates ? nextGuideFiles : currentGuideFiles;
}
